import { apiSecureRequest, constructUrlWithQueryParams, investmentEntityRequest } from '@utils/request';
import { AutoInvestOptions, AutoInvestSchedule, RecurringInvestmentScheduleSelections } from 'types/auto-invest';
import { AxiosResponse } from 'axios';

export async function getRecurringInvestmentSchedule(): Promise<AutoInvestSchedule> {
	const response = await investmentEntityRequest.get(`/recurring-investment`, {
		suppressToast: (response: AxiosResponse) => response.status === 404
	});
	return response.data;
}

export async function getAgreements(): Promise<Array<string>> {
	const response = await apiSecureRequest.get(`/recurring-investment/acknowledgements`);
	const formattedAgreements: Array<string> = response.data.map((ack: string) =>
		ack.replace(
			'fundrise.com/oc',
			'<a class="text-link" href="https://fundrise.com/oc" target="_blank">fundrise.com/oc</a>'
		)
	);

	return formattedAgreements;
}

export async function setRecurringInvestmentSchedule(autoInvestSchedule: AutoInvestSchedule): Promise<AxiosResponse> {
	const response = await investmentEntityRequest.post(`/recurring-investment`, {
		...autoInvestSchedule,
		paymentMethodId: autoInvestSchedule.bankAccount.id
	});

	return response;
}

export async function getFrequenciesAndAmounts(): Promise<AutoInvestOptions> {
	const response = await apiSecureRequest.get(`/recurring-investment/get-frequencies-and-amounts`);
	return response.data;
}

export async function getPotentialResumeDates(): Promise<Array<string>> {
	const response = await investmentEntityRequest.get(`/recurring-investment/get-potential-resume-dates`);
	return response.data;
}

export async function updateRecurringInvestmentSchedule(
	autoInvestSchedule: AutoInvestSchedule
): Promise<AxiosResponse> {
	const response = await investmentEntityRequest.put(`/recurring-investment`, {
		...autoInvestSchedule,
		paymentMethodId: autoInvestSchedule.bankAccount.id
	});

	return response;
}

export async function deleteRecurringInvestmentSchedule(reminderSet: boolean): Promise<AxiosResponse> {
	const urlWithParams = constructUrlWithQueryParams(`/recurring-investment`, { reminderSet: reminderSet });
	const response = await investmentEntityRequest.delete(urlWithParams);

	return response;
}

export async function setResumeDate(resumeDate: string): Promise<AxiosResponse> {
	const response = await investmentEntityRequest.post(`/recurring-investment/set-resume-date`, {
		resumeDate: resumeDate
	});

	return response;
}

export async function resumeRecurringInvestmentSchedule(): Promise<AxiosResponse> {
	const response = await investmentEntityRequest.post(`/recurring-investment/resume`);

	return response;
}

export async function cacheRecurringInvestmentScheduleSelections(
	selections: RecurringInvestmentScheduleSelections
): Promise<void> {
	await investmentEntityRequest.post(`/recurring-investment/selections/cache`, selections);
}

export async function loadRecurringInvestmentScheduleSelections(): Promise<RecurringInvestmentScheduleSelections> {
	const response = await investmentEntityRequest.get(`/recurring-investment/selections`);
	return response.data;
}
